import * as React from 'react';

import { Bar, Meter } from './index.style';

interface ProgressBarProps {
  progress: number;
}

const ProgressBar = ({ progress }: ProgressBarProps) => (
  <Meter>
    <Bar
      role="progressbar"
      aria-label="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
      progress={progress}
    />
  </Meter>
);

export default ProgressBar;
